import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { PersonalCgrService } from 'src/app/services/personal-cgr.service';
import { NumIdCargoGestorCan,  openModalMensaje, NumIdEstadoAsignado, RecupPartesFchInicio, gvCanal } from 'src/app/general/variables';
import { AsignaResponsableComponent } from '../General/asigna-responsable/asigna-responsable.component';
import { FurService } from 'src/app/services/fur.service';
import { Fur } from 'src/app/models/Fur';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
// import { EvidenciasComponent } from '../denuncia/evidencias/evidencias.component';
import { BodyDatosExpedienteComponent } from '../Dashboard/body-datos-expediente/body-datos-expediente.component';
import { RegistroDocumentoComponent } from '../registro-documento/registro-documento.component';
import { DatosRegistroComponent } from './datos-registro/datos-registro.component';
import { DgAsigRespComponent } from '../General/dg-asig-resp/dg-asig-resp.component';
import { ContenedorWebComponent } from '../formulario-web/contenedor-web/contenedor-web.component';


@Component({
  selector: 'app-asignar-informacion',
  templateUrl: './asignar-informacion.component.html',
  styleUrls: ['./asignar-informacion.component.css']
})

export class AsignarInformacionComponent implements OnInit {

  // listPersonalCgr:PersonalCgr[] = [];
  // listCargo:Cargo[] = [];
  numIdCargo: number = NumIdCargoGestorCan;
  @ViewChild(AsignaResponsableComponent) asignaResponsableC: AsignaResponsableComponent;
  // @ViewChild(EvidenciasComponent) evidenciasC : EvidenciasComponent;
  @ViewChild(BodyDatosExpedienteComponent) bodyDatosExpedienteC: BodyDatosExpedienteComponent;
  @ViewChild(RegistroDocumentoComponent) registroDocumentoC: RegistroDocumentoComponent;
  @ViewChild(DatosRegistroComponent) datosRegistroC: DatosRegistroComponent;
  @ViewChild(DgAsigRespComponent) dgAsigRespC: DgAsigRespComponent;
  @ViewChild(ContenedorWebComponent) contenedorWebC: ContenedorWebComponent;

  @Output() opRetornaAsignar = new EventEmitter();

  idFurParam: number = null;
  fur: Fur = new Fur();
  flgMostrarExp = false;
  flgMostrarOtr = false;
  flgMostrarFormWeb = false;
  flgMostrarInfor = false;

  constructor(protected maestraService: MaestrasService,
              protected personalCgrService: PersonalCgrService,
              protected furService: FurService,
              public dialog: MatDialog,
              public router: Router,
    // private route: ActivatedRoute,


    ) { }

  ngOnInit() {


  }

  mostrarRegistro(idFur: number) {

  }

  _Asignar() {

    let furId = null;
    let codFur = null;

    if (this.asignaResponsableC.ValidarDatos()) {

      return;

    }

    // return;

    this.fur.cfurIdusuasig = this.asignaResponsableC.strIdResponsable;
    this.fur.cfurDscindica = this.asignaResponsableC.strDscIndicacion;
    this.fur.nfurNumplazoasig = this.asignaResponsableC.numCantTiempo;
    this.fur.nfurIdplazoasig = this.asignaResponsableC.numIdPlazo;
    this.fur.nfurIdestado = NumIdEstadoAsignado;

    console.log('============Asignar FUR');
    console.log(this.fur);



    this.furService.ActualizarFur(this.fur).subscribe(data => {



      furId = data.nfurId;
      codFur = data.cfurCodigo;


      if (data.nfurId > 0) {

        openModalMensaje('Asignar Información', `Se asignó correctamente el registro ${codFur}, por favor verifique`, this.dialog).afterClosed().subscribe(result => {

          this._RetornarSeguimiento();

        });

      } else {

        openModalMensaje('Asignar Información', 'Ocurrió un problema en la actualización del registro', this.dialog).afterClosed().subscribe(result => {

          this._RetornarSeguimiento();

        });

        // flgGuardado = false;

        return;

      }

      // this.opGuardado.emit(flgGuardado);

      // return

    }, err => {

      console.log(err);
    });

  }

  _RetornarSeguimiento() {


    this.opRetornaAsignar.emit();

    // console.log("==========GlobalVars.CodUsuario");

    // console.log(GlobalVars.CodUsuario);

    // this.router.navigate(['/PanelPrincipal/',GlobalVars.CodUsuario], { relativeTo: this.route });

  }

  _Cancelar() {

    // openModalMensaje("Asignar Información",`¿Usted está seguro de salir de la Asignación de FUR?`,this.dialog).afterClosed().subscribe(result=>{

    //   this._RetornarSeguimiento();

    // });

    this._RetornarSeguimiento();

  }

}
